import { Layout, Row, Col } from "antd";
import { HeartFilled } from "@ant-design/icons";

import { Link } from "react-router-dom";
function Footer() {
  const { Footer: AntFooter } = Layout;

  return (
    <AntFooter style={{ background: "#fafafa" }}>
      <Row className="just">
        <Col xs={24} md={12} lg={12}>
          <div className="copyright">
            © 2021,
            {<HeartFilled />} by
            <a href="#pablo" className="font-weight-bold" target="_blank">
              Paul Oamen
            </a>
          </div>
        </Col>
        <Col xs={24} md={12} lg={12}>
          <div className="footer-menu">
            <ul>
              <li className="nav-item">Usefull Technologies</li>
              <li className="nav-item">
                <Link>About Us</Link>
              </li>
              <li className="nav-item">
                <Link>Contact Us</Link>
              </li>
            </ul>
          </div>
        </Col>
      </Row>
    </AntFooter>
  );
}

export default Footer;
